import classNames from 'classnames';
import './UserStatusBullet.scss';

type Props = {
    statusAvailable: boolean;
};
const UserStatusBullet = ({ statusAvailable }: Props) => {
    return (
        <div
            className={classNames('user-status-bullet', {
                'user-status-bullet--away': !statusAvailable
            })}
        />
    );
};

export default UserStatusBullet;
